module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.ebdcadff.svg";